import { FinancingConfigDto } from '@src/data/types/FinancingConfigDto'
import { getApiClient } from '@src/services/api-client'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

async function getMerchantFinancingConfig(merchantId: string, financingProgramId: string): Promise<FinancingConfigDto> {
  const apiClient = getApiClient()
  const response = await apiClient.get<FinancingConfigDto>(
    `/Merchants/${merchantId}/FinancingConfigs/${financingProgramId}`,
  )
  return response.data
}

export function useMerchantFinancingConfig(
  merchantId: string | undefined,
  financingProgramId: string | undefined,
): [FinancingConfigDto | undefined, boolean, AxiosError | null] {
  const { data, isFetching, error } = useQuery<FinancingConfigDto, AxiosError>({
    queryKey: ['financingConfigs', financingProgramId, merchantId],
    queryFn: () => getMerchantFinancingConfig(merchantId ?? '', financingProgramId ?? ''),
    enabled: merchantId != undefined && financingProgramId != undefined,
  })
  return [data, isFetching, error]
}
